"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.POSITIONS = void 0;
var POSITIONS = ['left', 'top', 'right', 'bottom'];
exports.POSITIONS = POSITIONS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25zdGFudHMudHMiXSwibmFtZXMiOlsiUE9TSVRJT05TIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBTyxJQUFNQSxTQUFTLEdBQUcsQ0FBQyxNQUFELEVBQVMsS0FBVCxFQUFnQixPQUFoQixFQUF5QixRQUF6QixDQUFsQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBQT1NJVElPTlMgPSBbJ2xlZnQnLCAndG9wJywgJ3JpZ2h0JywgJ2JvdHRvbSddIGFzIGNvbnN0O1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/redux-devtools-dock-monitor/lib/constants.js
// module id = 627
// module chunks = 0